import { render, staticRenderFns } from "./listComponent.vue?vue&type=template&id=93872f52&scoped=true&"
import script from "./listComponent.vue?vue&type=script&lang=js&"
export * from "./listComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93872f52",
  null
  
)

export default component.exports